export const API_HOST = process.env.REACT_APP_API;
export const IS_FC = process.env.REACT_APP_SITE_FAVICON === 'fullcycle'
